module.exports = __webpack_public_path__ + "4bd4b303100375d58ca7040dc161166b.svg";